// @flow
import t from "common/i18n";
import { PREDEFINED_KINDS } from "../data/consts";

const KINDS_VALUES = Object.values(PREDEFINED_KINDS);

export default (kind: string, name: string) => ((kind && ~KINDS_VALUES.indexOf(kind)) ? t(name) : name);
